import React from "react";
import { Eye } from "lucide-react";

export const etTime = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { timeZone: "America/New_York", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) + " ET" : "");

export const OpenAlerts = ({ alerts, onOpen }) => (alerts.length ? (
  <div className="mx-3 mb-3 rounded-lg border border-[#D4AF37]/40 bg-white/5 p-3" data-testid="helm-open-alerts">
    <p className="mb-2 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-amber-300"><Eye className="h-3.5 w-3.5" />Comparison opened ({alerts.length})</p>
    <ul className="space-y-1.5">
      {alerts.slice(0, 5).map((a) => (
        <li key={a.token}>
          <button type="button" onClick={() => onOpen(a)} className="w-full rounded-md px-2 py-1.5 text-left text-xs text-slate-200 hover:bg-white/10" data-testid={`helm-open-alert-${a.token}`}>
            <span className="block font-semibold text-white">{a.recipient_label}</span>
            <span className="text-slate-400">{etTime(a.first_opened_at)} · Open comparison</span>
          </button>
        </li>
      ))}
    </ul>
  </div>
) : null);
